import React from "react";
import { connect } from "react-redux";
import { Link, browserHistory } from "react-router";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
import { fileExcelO } from "react-icons-kit/fa/fileExcelO";
import SvgIcon from "react-icons-kit";

import { SURVEY_LIST_LOAD, SURVEY_LIST_UNLOAD, CONFIRM_ACTION_OPEN, LOGOUT } from "../../actions/Constants";
import api from "../../api/apiUtil";
import Title from "../../components/Layout/Title";
import MaskDate from "../../components/Util/MaskDate";
import "./Survey.css";

// XLSX export utilities
import XLSX from "xlsx/dist/xlsx.mini.min";
import * as FileSaver from "file-saver";

class SurveyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previewSurvey: null,
    };
  }

  componentWillMount() {
    // Usar o novo endpoint para carregar as pesquisas
    this.props.onLoad(Promise.resolve(api.Survey.all()));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  onActionDelete(survey) {
    this.props.onActionOpen({
      description: `Confirma a exclusão da pesquisa "${survey.titulo}"?`,
      onSuccess: () => this.deleteSurvey(survey.id),
    });
  }

  deleteSurvey(id) {
    var props = this.props;
    Promise.resolve(api.Survey.delete(id))
      .then(() => {
        toastr.success("Sucesso", "Pesquisa excluída!");
        this.props.onLoad(Promise.resolve(api.Survey.all()));
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else if (resp.message === "Não é possível excluir uma pesquisa que já possui respostas") {
          toastr.error("Erro", "Não é possível excluir uma pesquisa que já possui respostas!");
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  previewSurvey(survey) {
    this.setState({ previewSurvey: survey });
  }

  closePreview() {
    this.setState({ previewSurvey: null });
  }

  // Função para copiar uma pesquisa
  copySurvey(survey) {
    // Store the survey data in sessionStorage to pass it to the new survey page
    const surveyToCopy = {
      ...survey,
      // Clear title and status for the new survey
      titulo: "",
      habilitada: false,
      // We'll use the same perguntas (questions) structure
    };

    // Store in sessionStorage
    sessionStorage.setItem("copiedSurvey", JSON.stringify(surveyToCopy));

    // Redirect to new survey page
    browserHistory.push("/alias/surveyEdit/new");
  }

  // Função para obter o nome do tipo de pergunta
  getQuestionTypeName(type) {
    switch (type) {
      case "text":
        return "Texto Aberto";
      case "choice":
        return "Múltipla Escolha";
      case "rating":
        return "Avaliação (5 Estrelas)";
      case "likert":
        return "Escala Likert";
      default:
        return type;
    }
  }

  // Função para exportar respostas da pesquisa em XLSX
  exportSurveyResponsesToXlsx = async (survey) => {
    try {
      // Obter todas as respostas da pesquisa
      const responses = await api.Survey.getResponses(survey.id);

      if (!responses || responses.length === 0) {
        toastr.warning("Aviso", "Esta pesquisa não possui respostas para exportar.");
        return;
      }

      // Preparar os dados para exportação
      const exportData = responses.map((response) => {
        const rowData = {
          Nome: response.nomeUsuario || "",
          CPF: response.cpfUsuario || "",
          "Razão Social": response.razaoSocialFinanceira || "",
        };

        // Processar cada resposta - parse the resposta JSON string first
        let parsedResposta;
        try {
          parsedResposta = typeof response.resposta === "string" ? JSON.parse(response.resposta) : response.resposta;
        } catch (e) {
          console.error("Erro ao parsear resposta:", e);
          parsedResposta = { perguntas: [] };
        }

        // Processar as perguntas e respostas
        if (parsedResposta && parsedResposta.perguntas) {
          parsedResposta.perguntas.forEach((questionResponse) => {
            const question = survey.perguntas.find((q) => q.id === questionResponse.id);

            if (question) {
              if (question.tipo === "likert") {
                // Para perguntas Likert, criar colunas para cada item
                if (question.configuracao && question.configuracao.itensLikert && questionResponse.resposta) {
                  question.configuracao.itensLikert.forEach((item, itemIndex) => {
                    const columnName = `${question.titulo} - ${item.titulo}`;
                    const optionIndex = questionResponse.resposta[itemIndex];

                    if (question.configuracao.opcoesLikert && optionIndex !== undefined) {
                      const selectedOption = question.configuracao.opcoesLikert.find((opt) => opt.id === optionIndex);
                      rowData[columnName] = selectedOption ? selectedOption.texto : "";
                    } else {
                      rowData[columnName] = questionResponse.resposta[itemIndex] || "";
                    }
                  });
                }
              } else {
                // Para outros tipos de perguntas
                switch (question.tipo) {
                  case "choice":
                    if (question.configuracao && question.configuracao.opcoes) {
                      const selectedOption = question.configuracao.opcoes.find((opt) => opt.texto === questionResponse.resposta);
                      rowData[question.titulo] = selectedOption ? selectedOption.texto : questionResponse.resposta || "";
                    } else {
                      rowData[question.titulo] = questionResponse.resposta || "";
                    }
                    break;
                  case "rating":
                    rowData[question.titulo] = questionResponse.resposta || "";
                    break;
                  case "text":
                    rowData[question.titulo] = questionResponse.resposta || "";
                    break;
                  default:
                    rowData[question.titulo] = questionResponse.resposta || "";
                    break;
                }
              }
            }
          });
        }

        return rowData;
      });

      // Criar cabeçalho com as colunas
      const uniqueHeaders = [...new Set(exportData.flatMap((obj) => Object.keys(obj)))];

      // Ordenar as colunas: Nome, CPF, Razão Social primeiro, depois as perguntas
      const orderedHeaders = ["Nome", "CPF", "Razão Social", ...uniqueHeaders.filter((h) => !["Nome", "CPF", "Razão Social"].includes(h))];

      // Criar a planilha
      const ws = XLSX.utils.json_to_sheet(exportData, { header: orderedHeaders });

      // Ajustar largura das colunas
      const colWidths = orderedHeaders.map((header) => ({
        wch: Math.max(header.length, 15), // Largura mínima de 15 caracteres
      }));
      ws["!cols"] = colWidths;

      // Criar o workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Respostas da Pesquisa");

      // Gerar e baixar o arquivo
      const fileName = `Respostas_${survey.titulo.replace(/[^a-zA-Z0-9]/g, "_")}.xlsx`;
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);

      toastr.success("Sucesso", "Exportação concluída com sucesso!");
    } catch (error) {
      console.error("Erro ao exportar respostas:", error);
      toastr.error("Erro", "Ocorreu um erro ao exportar as respostas da pesquisa.");
    }
  };

  render() {
    // if (!this.props.listLoad) {
    //   return null;
    // }

    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Gerenciamento de Pesquisas de Satisfação" />

        {this.state.previewSurvey && (
          <div className="modal-preview">
            <div className="modal-content">
              <div className="modal-header">
                <h3>{this.state.previewSurvey.titulo}</h3>
                <button className="close" onClick={() => this.closePreview()}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Período: {MaskDate.TO_BR_DATE(this.state.previewSurvey.dataInicio)}
                  {this.state.previewSurvey.dataFim && ` até ${MaskDate.TO_BR_DATE(this.state.previewSurvey.dataFim)}`}
                </p>
                <p>Status: {this.state.previewSurvey.habilitada ? "Habilitada" : "Não Habilitada"}</p>

                <div className="questions-preview">
                  {this.state.previewSurvey.perguntas &&
                    this.state.previewSurvey.perguntas.map((question, index) => (
                      <div key={index} className="question-preview">
                        <h4>
                          {index + 1}. {question.titulo}
                          {question.obrigatoria && <span className="required"> *</span>}
                          <span className="question-type">({this.getQuestionTypeName(question.tipo)})</span>
                        </h4>

                        {question.tipo === "choice" && (
                          <div className="options-preview">
                            {question.configuracao &&
                              question.configuracao.opcoes &&
                              question.configuracao.opcoes.map((option, optionIndex) => (
                                <div key={optionIndex} className="option">
                                  <input type="radio" disabled /> {option.texto}
                                </div>
                              ))}
                          </div>
                        )}

                        {question.tipo === "rating" && (
                          <div className="rating-preview">
                            {(() => {
                              const scale = question.configuracao && question.configuracao.escala ? question.configuracao.escala : 5;
                              return Array.from({ length: scale }, (_, i) => (
                                <span key={i} className="star">
                                  ★
                                </span>
                              ));
                            })()}
                          </div>
                        )}

                        {question.tipo === "likert" && (
                          <div className="likert-preview">
                            <table>
                              <thead>
                                <tr>
                                  <th></th>
                                  {question.configuracao &&
                                    question.configuracao.opcoesLikert &&
                                    question.configuracao.opcoesLikert.map((option, optionIndex) => (
                                      <th key={optionIndex} className="text-center">
                                        {option.texto}
                                      </th>
                                    ))}
                                </tr>
                              </thead>
                              <tbody>
                                {question.configuracao &&
                                  question.configuracao.itensLikert &&
                                  question.configuracao.itensLikert.map((item, itemIndex) => (
                                    <tr key={itemIndex}>
                                      <td>{item.titulo}</td>
                                      {question.configuracao.opcoesLikert &&
                                        question.configuracao.opcoesLikert.map((option, optionIndex) => (
                                          <td key={optionIndex} className="text-center">
                                            <input type="radio" disabled />
                                          </td>
                                        ))}
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                        {question.tipo === "text" && (
                          <div className="text-preview">
                            <textarea disabled placeholder="Sua resposta aqui..." rows="3"></textarea>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-default" onClick={() => this.closePreview()}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">
                  <div className="panel-tools">
                    {this.props.currentUser.funcionalidades.includes(104) && (
                      <Link to="/alias/surveyEdit/new" className="btn btn-xs btn-info">
                        <i className="fas fa-plus" /> Nova Pesquisa
                      </Link>
                    )}
                  </div>
                  Pesquisas de Satisfação cadastradas
                </div>

                <div className="panel-body">
                  <div className="table-responsive">
                    {/* {this.props.surveys && this.props.surveys.length > 0 ? ( */}
                    <ReactTable
                      className="-striped -highlight"
                      defaultPageSize={10}
                      data={this.props.surveys}
                      loadingText="Carregando..."
                      noDataText="Nenhuma pesquisa encontrada"
                      previousText="Anterior"
                      nextText="Próximo"
                      pageText="página"
                      ofText="de"
                      rowsText="linhas"
                      showPageSizeOptions={false}
                      minRows={1}
                      columns={[
                        {
                          Header: "Título",
                          accessor: "titulo",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                        },
                        {
                          Header: "Status",
                          accessor: "habilitada",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                          Cell: (row) => {
                            return (
                              <div>
                                <span>{row.original.habilitada ? "Habilitada" : "Não Habilitada"}</span>
                                <br />
                              </div>
                            );
                          },
                        },
                        {
                          Header: "Período",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                          Cell: (row) => (
                            <div>
                              {MaskDate.TO_BR_DATE(row.original.dataInicio)}
                              {row.original.dataFim && ` até ${MaskDate.TO_BR_DATE(row.original.dataFim)}`}
                            </div>
                          ),
                        },
                        {
                          Header: "Respostas",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                          width: 100,
                          Cell: (row) => (
                            <div>
                              <span className="badge badge-info">{row.original.respostaCount || 0}</span>
                            </div>
                          ),
                        },
                        {
                          Header: "Ações",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                          width: 270, // Increased width to accommodate new button
                          Cell: (row) => (
                            <div className="btn-group">
                              {this.props.currentUser.funcionalidades.includes(105) && (
                                <Link to={`/alias/surveyEdit/${row.original.id}`} className="btn btn-xs btn-default" title="Editar">
                                  <i className="far fa-edit" />
                                </Link>
                              )}
                              {row.original.respostaCount > 0 && (
                                <Link to={`/alias/surveys/${row.original.id}/responses`} className="btn btn-xs btn-info" title="Ver Respostas">
                                  <i className="fas fa-chart-bar" />
                                </Link>
                              )}
                              {row.original.respostaCount > 0 && (
                                <button 
                                  className="btn btn-xs" 
                                  style={{ backgroundColor: '#800080', borderColor: '#800080', color: 'white' }}
                                  onClick={() => this.exportSurveyResponsesToXlsx(row.original)} 
                                  title="Exportar Respostas (XLSX)">
                                  <SvgIcon icon={fileExcelO} />
                                </button>
                              )}
                              {this.props.currentUser.funcionalidades.includes(107) && (
                                <button className="btn btn-xs btn-success" onClick={() => this.copySurvey(row.original)} title="Copiar Pesquisa">
                                  <i className="fas fa-copy" />
                                </button>
                              )}

                              <button className="btn btn-xs btn-warning" onClick={() => this.previewSurvey(row.original)} title="Visualizar">
                                <i className="fas fa-eye" />
                              </button>
                              {this.props.currentUser.funcionalidades.includes(106) && row.original.respostaCount === 0 && (
                                <button className="btn btn-xs btn-danger" onClick={() => this.onActionDelete(row.original)} title="Excluir">
                                  <i className="fas fa-trash" />
                                </button>
                              )}
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLoad: (payload) => dispatch({ type: SURVEY_LIST_LOAD, payload }),
  onUnload: () => dispatch({ type: SURVEY_LIST_UNLOAD }),
  onActionOpen: (payload) => dispatch({ type: CONFIRM_ACTION_OPEN, payload }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const mapStateToProps = (state) => ({
  ...state.surveyEdit,
  currentUser: state.common.currentUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyList);
